/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResendInvitationRequest
 */
export interface ResendInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof ResendInvitationRequest
     */
    inviteeEmailAddress: string;
}

/**
 * Check if a given object implements the ResendInvitationRequest interface.
 */
export function instanceOfResendInvitationRequest(value: object): value is ResendInvitationRequest {
    if (!('inviteeEmailAddress' in value) || value['inviteeEmailAddress'] === undefined) return false;
    return true;
}

export function ResendInvitationRequestFromJSON(json: any): ResendInvitationRequest {
    return ResendInvitationRequestFromJSONTyped(json, false);
}

export function ResendInvitationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'inviteeEmailAddress': json['inviteeEmailAddress'],
    };
}

  export function ResendInvitationRequestToJSON(json: any): ResendInvitationRequest {
      return ResendInvitationRequestToJSONTyped(json, false);
  }

  export function ResendInvitationRequestToJSONTyped(value?: ResendInvitationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inviteeEmailAddress': value['inviteeEmailAddress'],
    };
}

